/* eslint-disable max-len */

import DgbQuestion from 'images/coin-pages/questions/dgb.svg'

import { slides } from 'pages/home/components/swiper-component/assets/slides'

import { ECoinPageParagraphTypes, ICoinPageData } from '../types'

export const dgbPage: ICoinPageData = {
  title: 'coin_274',
  description: 'coin_275',
  // description: 'coin_276',
  questionsBlock: {
    image: DgbQuestion,
    questions: [
      {
        title: 'coin_277',
        answer: 'coin_278',
      },
      {
        title: 'coin_279',
        answer: 'coin_280',
      },
      {
        title: 'coin_281',
        answer: 'coin_282',
      },
      {
        title: 'coin_283',
        answer: 'coin_284',
      },
      {
        title: 'coin_285',
        answer: 'coin_286',
      },
      {
        title: 'coin_287',
        answer: 'coin_288',
      },
    ],
  },
  whatIs: {
    slides: slides,
    text: ['coin_291'],
    paragraphs: [
      {
        title: 'coin_289',
        text: ['coin_292', 'coin_293', 'coin_294', 'coin_295'],
      },
      {
        title: 'coin_290',
        text: ['coin_296'],
        type: ECoinPageParagraphTypes.ul,
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/exceeding-digibyte-using-dgb-as-collateral/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/06/DGB-feature-image.png',
        imageAlt: 'Digibyte (DGB) crypto review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-to-get-an-instant-digibyte-loan/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_827/https://coinrabbit.io/blog/wp-content/uploads/2021/08/Screenshot_2154646546.png',
        imageAlt: 'Digibyte (DGB) crypto review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Digibyte (DGB) crypto review 7',
      },
    ],
  },
}
